//https://github.com/vimeo/player.js#pause-promisevoid-passworderrorprivacyerrorerror
//https://developers.google.com/youtube/iframe_api_reference
import Player from '@vimeo/player';

$(function () {
    if (!$('#career-video-container').length) return;

    //Pause the video playback if the modal is closed
    $('.employee-video-modal').on('hide.bs.modal', function () {
        var iframe = $(this).find('iframe')[0];
        var isVimeo = iframe.src.includes('vimeo');
        var isYouTube = iframe.src.includes('youtube');

        if (iframe && isVimeo) {
            tryPauseVimeoVideo(iframe);
        } else if (iframe && isYouTube) {
            tryPauseYoutubeVideo(iframe);
        }
    });
})

function tryPauseVimeoVideo(iframe/*thisModal*/) {
    var player = new Player(iframe);
    player.pause().then(function () {
        // the video was paused
        console.info('The video was paused.');
    }).catch(function (error) {
        console.warn('An error has occured when attempting to pause the video: ', error);
        switch (error.name) {
            case 'PasswordError':
                // the video is password-protected and the viewer needs to enter the
                // password first
                break;

            case 'PrivacyError':
                // the video is private
                break;

            default:
                // some other error occurred
                break;
        }
    });
}

function tryPauseYoutubeVideo(iframe) {
    iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
}


// WEBPACK FOOTER //
// ./features/careers/careers.js